import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-[#1a3a2e] text-[#f4f1e8] py-20" data-id="element-53">
      {/* Background Texture */}
      <div className="absolute inset-0 bg-texture-grain opacity-30 pointer-events-none mix-blend-overlay" data-id="element-54"></div>

      {/* Decorative Corner Ornaments (CSS Shapes) */}
      <div className="absolute top-8 left-8 w-24 h-24 border-t-4 border-l-4 border-[#d4af37] opacity-60 rounded-tl-3xl" data-id="element-55"></div>
      <div className="absolute top-8 right-8 w-24 h-24 border-t-4 border-r-4 border-[#d4af37] opacity-60 rounded-tr-3xl" data-id="element-56"></div>
      <div className="absolute bottom-8 left-8 w-24 h-24 border-b-4 border-l-4 border-[#d4af37] opacity-60 rounded-bl-3xl" data-id="element-57"></div>
      <div className="absolute bottom-8 right-8 w-24 h-24 border-b-4 border-r-4 border-[#d4af37] opacity-60 rounded-br-3xl" data-id="element-58"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 text-center" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="border-8 border-[#d4af37] p-2 md:p-4 inline-block bg-[#1a3a2e] shadow-2xl" data-id="element-60">
          <div className="border-4 border-[#f4f1e8] p-8 md:p-16 relative" data-id="element-61">
            {/* Top flourish */}
            <div className="absolute top-4 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-[#d4af37]" data-id="element-62"></div>

            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.5,
            duration: 0.8
          }} className="font-script text-2xl md:text-4xl text-[#d4af37] mb-4 transform -rotate-2" data-id="element-63">
              Est. 1954
            </motion.p>

            <motion.h1 initial={{
            scale: 0.9,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            delay: 0.2,
            duration: 0.8,
            type: 'spring'
          }} className="font-display text-7xl md:text-9xl lg:text-[10rem] leading-none text-[#f4f1e8] text-shadow-vintage tracking-wider mb-6" data-id="element-64">
              KMI POLSKA
            </motion.h1>

            <motion.div initial={{
            width: 0
          }} animate={{
            width: '100%'
          }} transition={{
            delay: 0.8,
            duration: 1
          }} className="h-1 bg-[#d4af37] w-full mb-6 mx-auto" data-id="element-65"></motion.div>

            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 1,
            duration: 0.8
          }} className="font-serif text-xl md:text-2xl tracking-widest uppercase text-[#f4f1e8] opacity-90" data-id="element-66">
              Tradycja • Rzemiosło • Jakość
            </motion.p>

            {/* Bottom flourish */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-[#d4af37]" data-id="element-67"></div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5,
        duration: 1
      }} className="mt-12" data-id="element-68">
          <p className="font-script text-[#d4af37] text-2xl md:text-3xl" data-id="element-69">
            Najlepsze szyldy w mieście
          </p>
        </motion.div>
      </div>
    </section>;
}